import React, { useEffect } from "react";
import "./login-register-forget.less";
import { LoginBg, Header } from "./login/login";
import { PLATFORM_CODE } from "./oauth/types";
import useOauth from "../components/hook/useOauth";

export const ADMIN = "admin";
export const USER = "user";
export const loginRoleList = [
    {
        icon: "https://dante-img.oss-cn-hangzhou.aliyuncs.com/14449727493.svg",
        title: "商家",
        desc: "进行货品、库存、店铺和单据等操作",
        bg: "linear-gradient(270deg, #FFF3D8 0%, #FFFBF2 100%)",
        role: "user",
        rootPath: "/login",
        url: `/login/login`,
    },
    {
        icon: "https://dante-img.oss-cn-hangzhou.aliyuncs.com/14449728902.svg",
        title: "运营小二",
        desc: "仓储运营方",
        bg: "linear-gradient(270deg, #EBF3FF 0%, #F2F7FF 100%)",
        role: "admin",
        rootPath: "/login-admin",
        url: `/login-admin/login`,
    },
    {
        icon: "https://dante-img.oss-cn-hangzhou.aliyuncs.com/14449728445.svg",
        title: "仓库人员",
        desc: "登录WMS系统",
        bg: "linear-gradient(270deg, #EBF3FF 0%, #F2F7FF 100%)",
        role: "wms",
        rootPath: "/login",
        url: `/login/login`,
    },
];

/**
 *
 * @param {Object} props
 * @param {string} props.saasInfo - 租户信息
 * @param {string} props.loading - 租户信息加载中
 * @param {PLATFORM_CODE=} props.platformCode - 环境平台
 * @return {JSX.Element}
 */
export default function SelectRole(props) {
    useEffect(() => {
        if (!props.platformCode && localStorage.getItem("role")) {
            location.href = `${
                localStorage.getItem("role") === ADMIN ? "/login-admin/" : "/login/"
            }login${location.search}`;
        }
    }, []);
    const { toOauth, getRedirectUri } = useOauth({});
    return (
        <>
            <LoginBg />
            <Header saasInfo={props.saasInfo} loading={props.loading} />
            <div className={"login-container"}>
                {props.saasInfo.loginPic ? (
                    <img
                        src={props.saasInfo.loginPic}
                        height={"395"}
                        width={"520"}
                        className={"left-bg"}
                    />
                ) : (
                    <div style={{ width: "520px", height: "395px" }}></div>
                )}

                <div className={"login-wrap"}>
                    <div className="lpr-content">
                        <div className="lpr-role-select">
                            <img src="https://dante-img.oss-cn-hangzhou.aliyuncs.com/13451059725.png" />
                            选择您登录的身份
                            <img src="https://dante-img.oss-cn-hangzhou.aliyuncs.com/13451059725.png" />
                        </div>
                        <div className="lqr-role-content">
                            {loginRoleList.map((item, index) => (
                                <div
                                    className="lqr-role-item"
                                    style={{ background: item.bg }}
                                    key={index}
                                    onClick={() => {
                                        localStorage.setItem("role", item.role);
                                        localStorage.setItem("roleName", item.title);
                                        if (props.platformCode && item.role !== USER) {
                                            const rootPath =
                                                item.role === ADMIN ? "/login-admin" : "/login";
                                            if (window.isWxWork) {
                                                toOauth(item.role, props.platformCode, rootPath);
                                            } else {
                                                location.href = getRedirectUri(
                                                    rootPath,
                                                    item.role,
                                                    props.platformCode,
                                                );
                                            }
                                        } else {
                                            location.href = item.url;
                                        }
                                    }}>
                                    <img className="role-icon" src={item.icon} />
                                    <div className="lqr-role-item-content">
                                        <div className="role-title">我是{item.title}</div>
                                        <div className="role-desc">{item.desc}</div>
                                    </div>
                                    <img
                                        className="role-right-icon"
                                        src="https://dante-img.oss-cn-hangzhou.aliyuncs.com/17518505957.svg"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
